import { HandType } from '@ps/web-poker-types';

import { legacyHandTypeToAssetNameMap } from '../types';

import { BASE_POKER_STR, Structure, TILE_IMAGE_FORMAT, getRailCdnBaseUrl } from './game';

export default function imageZoomFormatter(
  game: number,
  structure: number,
  buyIn: number,
  isOneOnOne: number,
  isThemeV2Image?: boolean
) {
  // @ts-ignore TODO: fix types
  const gameStr = legacyHandTypeToAssetNameMap[game].toLowerCase();
  const structureStr = Structure[structure].toLowerCase();
  // @ts-ignore TODO: fix types
  const railCdnBaseUrl = getRailCdnBaseUrl(isThemeV2Image);

  if (isOneOnOne !== 0) {
    return `${railCdnBaseUrl}${BASE_POKER_STR}zoom_heads_up${TILE_IMAGE_FORMAT}`;
  }

  if (
    (HandType[game] === HandType[HandType.OMAHA] && structureStr === 'pl') ||
    (HandType[game] === HandType[HandType.HOLDEM] && structureStr === 'nl')
  ) {
    return `${railCdnBaseUrl}${BASE_POKER_STR}${structureStr}_zoom_${gameStr}${TILE_IMAGE_FORMAT}`;
  }

  return `${railCdnBaseUrl}${BASE_POKER_STR}zoom${TILE_IMAGE_FORMAT}`;
}
